import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'
import { ROUTES } from '@/constants/routes'
import { Layout } from '@/components/Layout/Layout'

const HomePage = lazy(() => import('@/pages/Home/HomePage'))
const CatalogPage = lazy(() => import('@/pages/Catalog/CatalogPage'))
const AboutPage = lazy(() => import('@/pages/About/AboutPage'))
const ContactsPage = lazy(() => import('@/pages/Contacts/ContactsPage'))
const FinancePage = lazy(() => import('@/pages/Finance/FinancePage'))
const BlogPage = lazy(() => import('@/pages/Blog/BlogPage'))
const ArticlePage = lazy(() => import('@/pages/Article/ArticlePage'))
const NotFoundPage = lazy(() => import('@/pages/NotFound/NotFoundPage'))

export const appRoutes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: ROUTES.HOME, element: <HomePage /> },
      { path: ROUTES.CATALOG, element: <CatalogPage /> },
      { path: ROUTES.ABOUT, element: <AboutPage /> },
      { path: ROUTES.CONTACTS, element: <ContactsPage /> },
      { path: ROUTES.FIN_SERVICES, element: <FinancePage /> },
      { path: ROUTES.BLOG, element: <BlogPage /> },
      { path: `${ROUTES.BLOG}/:slug`, element: <ArticlePage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]
